import * as CostCategory from '@/services/rest-api/lib/cost-management/category'

const templateItemFields = [
  {
    name: 'activity_id',
    key: 'activity.name',
    label: 'Nama Kategori Biaya',
    placeholder: 'Pilih jenis biaya',
    isEditable: true,
    isSortable: false,
    validation: 'required',
    type: 'select-resourceful',
    trackBy: 'id',
    displayedBy: 'name',
    optionsGetter: CostCategory.get,
    optionLabelFn: ({ item }) => item.name,
    getInitialObject: (obj) => obj,
    thStyle: 'width: 150px'
  },
  {
    name: 'amount',
    key: 'amount',
    label: 'Biaya',
    _type: 'number',
    placeholder: 'Masukkan Biaya',
    validation: 'bail|required|number|min:1,value|max:100000000000,value',
    'validation-messages': {
      min: 'Harus lebih dari 0',
      max: 'Maksimal 100,000,000,000'
    },
    value: 1,
    isEditable: true,
    isSortable: false,
    thStyle: 'width: 150px',
    tdClass: 'mc-amount-col-head'
  }
]

export default templateItemFields
